(() => {
  const params = new URLSearchParams(location.search);
  const values = params.getAll('enquiry_message');
  if (values.length !== 1 || !values[0] || values[0].length > 10000) return;
  const page = document.querySelector('[data-receiver-family]');
  const form = page?.querySelector('#MoltenEnquiry');
  const message = form?.elements['contact[body]'];
  if (!message || message.value || message.readOnly || form.dataset.enquiryState) return;
  try {
    if (sessionStorage.getItem('molten-direct-enquiry-' + page.dataset.receiverFamily + '-v1')) return;
  } catch { return; }
  message.value = values[0];
})();
